import { getUrl, sessionExpired } from '../setEnvironment';

class EntryStrategiesAPI {
  constructor() {
    this.URL = getUrl();
    this.getEntryStrategies = this.getEntryStrategies.bind(this);
    this.getEntryStrategyById = this.getEntryStrategyById.bind(this);
    this.createEntryStrategy = this.createEntryStrategy.bind(this);
    this.updateEntryStrategy = this.updateEntryStrategy.bind(this);
    this.toggleEntryStrategy = this.toggleEntryStrategy.bind(this);
    this.addAreaEntryStrategy = this.addAreaEntryStrategy.bind(this);
    this.reorderAreaEntryStrategy = this.reorderAreaEntryStrategy.bind(this);
    this.removeAreaEntryStrategy = this.removeAreaEntryStrategy.bind(this);
    this.deleteEntryStrategy = this.deleteEntryStrategy.bind(this);
    this.toggleAreaEntryStrategy = this.toggleAreaEntryStrategy.bind(this);
  }

  async getEntryStrategies({ token }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/getAll`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error fetching entry strategies');
      }

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async getEntryStrategyById(token, id) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/getById/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error fetching entry strategy by ID');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async createEntryStrategy({ token, name }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          name,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error creating entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateEntryStrategy({ token, id, name }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/update`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          id,
          name,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error updating entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async toggleEntryStrategy({ token, id, active }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/toggle`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          id,
          active,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error toggling entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async toggleAreaEntryStrategy({ token, id, active }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/toggleArea`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          id,
          active,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error toggling area in entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async addAreaEntryStrategy({ token, strategyId, rcsArea, sortOrder }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/addArea`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          strategyId,
          rcsArea,
          sortOrder,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error adding area to entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async reorderAreaEntryStrategy({ token, strategyId, areas }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/reorderAreas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          strategyId,
          areas, // Recibe el formato [{ areaId, sortOrder }] mapeado en el componente
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error reordering areas in entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async removeAreaEntryStrategy({ token, areaId }) {
    try {
      // ➔ CORREGIDO: método cambiado a 'DELETE' y payload adaptado para el backend
      const response = await fetch(`${this.URL}/entry-strategy/removeArea`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          areaId,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error removing area from entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async deleteEntryStrategy({ token, id }) {
    try {
      const response = await fetch(`${this.URL}/entry-strategy/delete`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({
          id,
        }),
      });
      if (sessionExpired(response.status)) return;
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error deleting entry strategy');
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

let _entryStrategiesAPI = null;

const initEntryStrategiesAPI = () => {
  if (!_entryStrategiesAPI) {
    _entryStrategiesAPI = new EntryStrategiesAPI();
  }
  return _entryStrategiesAPI;
};

const getEntryStrategiesAPI = () => {
  return initEntryStrategiesAPI();
};

export { initEntryStrategiesAPI, getEntryStrategiesAPI };
